import $http from './http'
import config from './config'
export default {
    name: 'hotel',
    getUrl(url) {
        return config.getUrl(this.name, url);
    },
    CheckRepeatOrder(data) {
        return $http.post(this.getUrl('/HotelOrder/CheckRepeatOrder'), data, {
            failTips: false
        });
    },
    CreateOrder(data) {
        return $http.post(this.getUrl(`/HotelOrder/CreateOrder`), data);
    },
    OrderDetails(UniqueID) {
        return $http.get(this.getUrl(`/HotelOrder/OrderDetails?UniqueID=${UniqueID}`));
    },
    OrderSubmit(UniqueID) {
        return $http.get(this.getUrl(`/HotelOrder/OrderSubmit/${UniqueID}`));
    },
    // CreateReceiveRequest(data) {
    //     return $http.post(this.getUrl('/HotelOrder/CreateReceiveRequest'), data);
    // },
    // TradeSubmit(id) {
    //     return $http.get(this.getUrl(`/HotelOrder/SubmitReceiveRequest?TradeID=${id}`));
    // },
    OrderCannot(id) {
        return $http.get(this.getUrl(`/HotelOrder/OrderCannot?UniqueID=${id}`));
    },
    OrderDrawer(id) {
        return $http.get(this.getUrl(`/HotelOrder/OrderDrawer?UniqueID=${id}`));
    },
    OrderReject(id) {
        return $http.get(this.getUrl(`/HotelOrder/OrderReject?UniqueID=${id}`));
    },
    OrderResolve(data) {
        return $http.post(this.getUrl(`/HotelOrder/OrderResolve`), data);
    },
    UpdateGoods(goods) {
        return $http.post(this.getUrl('/HotelOrder/UpdateGoods'), goods);
    },
    CreateAmend(amend) {
        return $http.post(this.getUrl(`/HotelOrder/CreateAmend`), amend)
    },
    SubmitAmend(UniqueID) {
        return $http.get(this.getUrl(`/HotelOrder/SubmitAmend/${UniqueID}`));
    },
    AmendDetails(UniqueID) {
        return $http.get(this.getUrl(`/HotelOrder/AmendDetails?UniqueID=${UniqueID}`));
    },
    OrderCancel(id) {
        return $http.get(this.getUrl(`/HotelOrder/OrderCancel?UniqueID=${id}`), {
            failTips: false
        });
    },
    OrderUnLock(id) {
        return $http.get(this.getUrl(`/HotelOrder/OrderUnLock?UniqueID=${id}`));
    },
    OrderLock(id) {
        return $http.get(this.getUrl(`/HotelOrder/OrderLock?UniqueID=${id}`));
    },
    OrderRefund(data) {
        return $http.post(this.getUrl('/HotelOrder/OrderRefund'), data);
    },
    ClientOrderResolve(data) {
        return $http.post(this.getUrl('/HotelOrder/ClientOrderResolve'), data);
    },
    HotelPay(id) {
        return $http.get(this.getUrl(`/HotelOrder/HotelPay?UniqueID=${id}`));
    },
    RefundSubmit(id) {
        return $http.get(this.getUrl(`/HotelOrder/RefundSubmit?UniqueID=${id}`));
    },
    OrderRefundCancel(id) {
        return $http.get(this.getUrl(`/HotelOrder/OrderRefundCancel?UniqueID=${id}`));
    },
    ConfirmOrderPrice(data) {
        return $http.post(this.getUrl(`/HotelOrder/ConfirmOrderPrice`), data)
    },
    UpdateOrderStatus(id) {
        return $http.get(this.getUrl(`/HotelOrder/UpdateOrderStatus?UniqueID=${id}`));
    },
    UpdateOrderPrice(data) {
        return $http.post(this.getUrl('/HotelOrder/UpdateOrderPrice'), data);
    },
    AmendStatusBack(id) {
        return $http.get(this.getUrl(`/HotelOrder/AmendStatusBack?UniqueID=${id}`));
    },

    CreateTrade(data) {
        return $http.post(this.getUrl(`/HotelOrder/CreateTrade`), data);
    },

    ConfirmClientAmendPrice(data){
        return $http.post(this.getUrl('/HotelOrder/ConfirmClientAmendPrice'),data)
    },

    ConfirmSupplyAmendPrice(data){
        return $http.post(this.getUrl('/HotelOrder/ConfirmSupplyAmendPrice'),data)
    },

    getOrderList(data) {
        return $http.post(this.getUrl('/HotelOrder/List'), data);
    },
    AmendList(data) {
        return $http.post(this.getUrl('/HotelAmend/List'), data);
    },
    CreateRefundRequest(data) {
        return $http.post(this.getUrl('/HotelOrder/CreateRefundRequest'), data);
    },
    RefundJudge(UniqueID) {
        return $http.get(this.getUrl(`/HotelOrder/RefundJudge?UniqueID=${UniqueID}`));
    },

    UpdateOrder(data) {
        return $http.post(this.getUrl('/HotelOrder/UpdateOrder'), data)
    },
    MessageSend(data) {
        return $http.post(this.getUrl('/HotelOrder/MessageSend'), data);
    },


    HotelOrder(data) {
        return $http.post(this.getUrl(`/HotelOrder/HotelOrder`), data);
    },
    HotelDetail(id) {
        return $http.get(this.getUrl(`/HotelOrder/HotelDetail/${id}`));
    },
    CreateOrderByPreference(data) {
        return $http.post(this.getUrl('/HotelOrder/CreateOrderByPreference'), data);
    },
    SearchOrders(id) {
        return $http.get(this.getUrl(`/HotelOrder/SearchOrders?UniqueID=${id}`));
    },
    getRefundPrice(id) {
        return $http.get(this.getUrl(`/hotelorder/RefundPrice?id=${id}`));
    },
    CreateAmendTradeDeal(id){
        return $http.get(this.getUrl('/hotelorder/CreateAmendTradeDeal?UniqueID='+id))
    },
    ConfirmPay(id,smscode){
        return $http.get(this.getUrl(`/hotelorder/ConfirmPay?UniqueId=${id}&smscode=${smscode}`))
    },
    SearchExtras(data) {
        return $http.post(this.getUrl('/HotelOrder/SearchExtras'), data);
    },
    CreateExtras(data) {
        return $http.post(this.getUrl('/HotelOrder/CreateExtras'), data);
    },
    SendEmail(orderId,unionId,email) {
            return $http.get(this.getUrl('/HotelOrder/SendEmail?orderId='+orderId+'&UnionId='+unionId+'&email='+email));
    },
    getHotelOrderID(ClientUniqueID){
        return $http.get(this.getUrl(`/hotelorder/GetOrderIDByClientUniqueID?ClientUniqueID=${ClientUniqueID}`),{failTips:false})
    },
    UpdateOrderClientUniqueId(data) {
        return $http.post(this.getUrl('/hotelorder/UpdateOrderClientUniqueId'), data);
    },
    downLoadPdf(UniqueID, config = {}){
        return $http.get(this.getUrl(`/hotelorder/downLoadPdf?UniqueID=${UniqueID}`),{failTips:false, ...config})
    },
    UpdateOrderSupplyStatus(UniqueID) {
        return $http.get(this.getUrl(`/hotelorder/UpdateOrderSupplyStatus?UniqueID=${UniqueID}`));
    },
}



// WEBPACK FOOTER //
// ./src/apis/hotelApi.js